import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup, Radio } from 'react-bootstrap';

const ProposerType = (props) => {
  return (
    <FormGroup controlId={props.proposerTypeId}>
      <Col componentClass={ControlLabel} sm={5}>
        Proposer Type
      </Col>
      <Col sm={7}>
          <Radio
            name={props.proposerTypeId}
            inline
            value="Individual"
            checked={props.proposerType === 'Individual'}
            onChange={props.handleChangeProposerType}
          >Individual</Radio>
          <Radio
            name={props.proposerTypeId}
            inline
            value="Corporate"
            checked={props.proposerType === 'Corporate'}
            onChange={props.handleChangeProposerType}
          >Corporate</Radio>
      </Col>
    </FormGroup>
  )
}

ProposerType.propTypes = {
  proposerType: PropTypes.string,
  handleChangeProposerType: PropTypes.func,
  proposerTypeId: PropTypes.string
};

export default ProposerType;



// WEBPACK FOOTER //
// ./src/app/components/proposerType/ProposerType.js